import { getFirstAndLastDayOfThisMonth } from '@fora-monorepo/date-utils';
import { FAGroupViewModel, FokParameterInfo } from '@fora-monorepo/employer-my-pages-common/types';

const defaultValues: Pick<FAGroupViewModel, 'kabId' | 'kabName' | 'isExpiring'> = {
  kabId: 'KAB123456',
  kabName: 'Kabname',
  isExpiring: false,
};

const pensionParameters: FokParameterInfo[] = [
  { parameterValue: 'TILLVAL_ASL65+', parameterDescription: 'Avtalspension SAF-LO 65+' },
  { parameterValue: 'TILLVAL_KP65+', parameterDescription: 'Kompletterande Pension 65+' },
];
const generateValidToForExpiringGroup = () => getFirstAndLastDayOfThisMonth().lastDayOfMonth.split('T')[0];

export const mockFAGroupHelpers = {
  defaultValues,
  pensionParameters,
  generateValidToForExpiringGroup,
};
